export default {
    unsubscribed_contacts_main_title: 'Contactos dados de baja',
    unsubscribed_contacts_main_add_unsubscribed_contact: 'Agregar Contacto dado de Baja',
    unsubscribed_contacts_main_id: 'Id',
    unsubscribed_contacts_main_to: 'Para',
    unsubscribed_contacts_main_via: 'Via',
    unsubscribed_contacts_main_source: 'Fuente',
    unsubscribed_contacts_main_reason: 'Razon',
    unsubscribed_contacts_main_30: 'Spam detectado',
    unsubscribed_contacts_main_50: 'Número de destino no válido',
    unsubscribed_contacts_main_70: 'Destino permanentemente no disponible',
    unsubscribed_contacts_main_100: 'Prohibido por el operador',
    unsubscribed_contacts_main_200: 'Número de origen bloqueado por STOP desde el número de destino',
    unsubscribed_contacts_main_details: 'Detalles',
    unsubscribed_contacts_main_created_on: 'Creado en',
    unsubscribed_contacts_main_created_by: 'Creado por',
    unsubscribed_contacts_main_via_sms: 'SMS',
    unsubscribed_contacts_main_via_email: 'Correo',
};